export class PerimeterAreaConstants {
  static defaultPerimeter: number = 7.00;
  static defaultArea: number = 10.00;
}
